<template>
  <div class="cbjl-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.ordernum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="拆包类型"
                    width="90"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.type===1" size="mini" :disable-transitions="true" type="warning">部件拆除</el-tag>
                      <el-tag v-if="scope.row.type===2" size="mini" :disable-transitions="true" type="danger">整包拆除</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包标签号"
                    width="180"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.packnum}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包号"
                    width="90"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.packxuhao}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="部件数量"
                    width="90"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="拆包人"
                    width="90"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.username}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="拆包时间"
                    min-width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button size="mini" @click="openDetails(scope.row)" icon="el-icon-link">部件详细</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="70%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="editForm" :inline="true" :model="editForm" label-width="70px">
        <el-form-item label="区域" prop="area">
          <el-select v-model="editForm.area" style="width: 200px" filterable clearable>
            <el-option v-for="item in areaList" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类" prop="type">
          <el-select v-model="editForm.type" style="width: 100px" filterable clearable>
            <el-option v-for="item in typeList" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字" prop="content">
          <el-input v-model="editForm.content" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchInfo" icon="el-icon-search">搜索</el-button>
        </el-form-item>
      </el-form>
      <div style="height: 400px;width: 100%" v-loading="editLoading">
        <pl-table
          height="400px"
          :key="tableKey"
          :datas="editTableData"
          :data="editTableData"
          use-virtual
          :pagination-show="false"
          size="small"
          :row-height="45">
          <pl-table-column prop="bar" :resizable="false" align="center" fixed label="条码" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="xuhao" :resizable="false" align="center" fixed label="序号" show-overflow-tooltip width="80"></pl-table-column>
          <pl-table-column prop="area" :resizable="false" align="center" label="区域" show-overflow-tooltip width="100"></pl-table-column>
          <pl-table-column prop="type" :resizable="false" align="center" label="分类" show-overflow-tooltip width="80"></pl-table-column>
          <pl-table-column prop="name" :resizable="false" align="center" label="名称" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="material" :resizable="false" align="center" label="基材" show-overflow-tooltip width="80"></pl-table-column>
          <pl-table-column :resizable="false" align="center" label="规格" show-overflow-tooltip width="140">
            <template slot-scope="scope">
              <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
              <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
              <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
              <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
              <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
            </template>
          </pl-table-column>
          <pl-table-column prop="color" :resizable="false" align="center" label="颜色" show-overflow-tooltip min-width="130"></pl-table-column>
        </pl-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpOrderUnpackRecordList, getErpOrderUnpackRecordInfoList } from '@/api/erp'

export default {
  name: 'cbjl',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editTitle: '',
      editVisible: false,
      editLoading: false,
      ourid: '',
      isfirst: false,
      areaList: [],
      typeList: [],
      editTableData: [],
      tableKey: '',
      editForm: {
        area: '',
        type: '',
        content: ''
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role
      }
      getErpOrderUnpackRecordList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      if (row.bid === 3) {
        this.editTitle = row.ordernum + ' 拆包记录部件明细'
      } else {
        this.editTitle = row.produnum + ' 拆包记录部件明细'
      }
      this.ourid = row.ourid
      this.isfirst = true
      this.areaList = []
      this.typeList = []
      this.editForm.area = ''
      this.editForm.type = ''
      this.editForm.content = ''
      this.editVisible = true
      this.searchInfo()
    },
    searchInfo() {
      this.editTableData = []
      this.editLoading = true
      const data = {
        ourid: this.ourid,
        area: this.editForm.area,
        type: this.editForm.type,
        content: this.editForm.content
      }
      getErpOrderUnpackRecordInfoList(data).then(response => {
        this.tableKey = new Date().getTime()
        this.editTableData = response.data
        if (this.isfirst) {
          let areaList = []
          let typeList = []
          for (let p of response.data) {
            let ishavearea = false
            for (let area of areaList) {
              if (area === p.area) {
                ishavearea = true
                break
              }
            }
            if (!ishavearea) {
              areaList.push(p.area)
            }
            let ishavetype = false
            for (let type of typeList) {
              if (type === p.type) {
                ishavetype = true
                break
              }
            }
            if (!ishavetype) {
              typeList.push(p.type)
            }
          }
          this.areaList = areaList
          this.typeList = typeList
          this.isfirst = false
        }
        this.editLoading = false
      }).catch(() => {
        this.editLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cbjl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
